export const black = "#000000";
export const white = "#ffffff";

export const grey = {
  0: "#f9fbfc",
  100: "#eef3f5",
  200: "#e4ecef",
  250: "#dcdcdc",
  300: "#cfd9dd",
  400: "#b4bfc4",
  450: "#b8b8b8",
  500: "#94a5ac",
  550: "#b2b1c4",
  600: "#8f8d9f",
  650: "#7a7a7a",
  800: "#65646f",
  900: "#403f4b",
  950: "#212121",
};

export const blue = {
  100: "#e4f6ff",
  200: "#e0ecef",
  350: "#a8e2ff",
  500: "#0d95d9",
  800: "#434b6c",
};

export const red = {
  100: "#ffebea",
  250: "#ffcac9",
  400: "#ff6f6c",
  500: "#ff4945",
  700: "#db221e",
};

export const green = {
  100: "#e2f2da",
  200: "#c9f1b4",
  600: "#2f7f07",
};

export const yellow = {
  100: "#fff8da",
  200: "#fff4c5",
  400: "#ffd41f",
  600: "#f0c81f",
  700: "#dbaa0a",
  900: "#a68004",
};

export const violet = {
  100: "#e5e4f6",
  600: "#544ac8",
};

export const brown = {
  600: "#6e5400",
  800: "#4e3c01",
};

export const lightGreen = {
  100: "#e8ffc5",
  500: "#809b15",
};

export const purple = {
  100: "#fdeaff",
  500: "#b624c5",
};

export const violetRed = {
  100: "#ffe0ee",
  500: "#cc3277",
};

export const orange = {
  100: "#fff3ea",
  500: "#e5711a",
};

export const citron = {
  100: "#f5ffc5",
  500: "#a1b514",
};

export const aquamarine = {
  100: "#d9f9f0",
  500: "#49947e",
};

export const navyBlue = {
  100: "#e0edfd",
  500: "#4b76b2",
};

export const violetBlue = {
  100: "#e0e6fd",
  500: "#4b60b2",
};

export const darkBlue = {
  100: "#d9f3f9",
  500: "#498594",
};
